import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export const PublishIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon width={16} height={16} viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="M7.1175 15.33V5.85825L4.56615 8.4096L3.79089 7.62339L7.665 3.74819L11.5391 7.62339L10.7649 8.4107L8.2125 5.85825V15.33H7.1175ZM0 4.42161V1.76842C0 1.26472 0.168995 0.844245 0.506985 0.506985C0.844245 0.168995 1.26472 0 1.76842 0H13.5616C14.0653 0 14.4858 0.168995 14.823 0.506985C15.161 0.844245 15.33 1.26472 15.33 1.76842V4.42161H14.235V1.76842C14.235 1.60052 14.1649 1.44613 14.0248 1.30524C13.8839 1.16508 13.7295 1.095 13.5616 1.095H1.76842C1.60052 1.095 1.44613 1.16508 1.30524 1.30524C1.16508 1.44613 1.095 1.60052 1.095 1.76842V4.42161H0Z"
      />
    </SvgIcon>
  );
};
